import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  Input 
} from '@angular/core';

@Directive({
  selector: '[clickOutside]',
  standalone: true
})
export class ClickOutsideDirective { 
  @Output() clickOutside = new EventEmitter<Event>();
  @Input() clickOutsideIgnore: HTMLElement[] = [];

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  onEvent(event: Event) {
    const target = event.target as Node;

    const clickedInside = this.elementRef.nativeElement.contains(target);
    const ignored = this.clickOutsideIgnore.some(el => el?.contains(target));

    if (!clickedInside && !ignored) {
      this.clickOutside.emit(event);
    }
  }
}